import { useSpeechRecognition } from "./useSpeechRecognition";
import { useDeepgramTranscription } from "./useDeepgramTranscription";
import { isWebSpeechReliable } from "../utils/browserDetect";

interface UseTranscriptionOptions {
  language: string;
  checkinToken?: string;
}

export function useTranscription({
  language,
  checkinToken,
}: UseTranscriptionOptions) {
  const useWebSpeech = isWebSpeechReliable();

  const webSpeech = useSpeechRecognition(language);
  const deepgram = useDeepgramTranscription({
    language,
    checkinToken: checkinToken || "",
  });

  // Use Web Speech API when reliable, otherwise fall back to Deepgram if we have a token
  if (useWebSpeech) {
    return { ...webSpeech, isConnecting: false, engine: "webspeech" as const };
  }

  if (checkinToken) {
    return { ...deepgram, engine: "deepgram" as const };
  }

  // No reliable engine available — return web speech (will show as unsupported)
  return { ...webSpeech, isConnecting: false, engine: "webspeech" as const };
}
